import { BodyLarge } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import React from 'react'

import ButtonCircleIcon from '@/components/ButtonCircleIcon'
import LocationZone from '@/components/Icon/LocationZone'
import { ContextValue } from '@/context/Cities'
import { useDevice } from '@/context/Device'
import { ModalContextType } from '@/context/ModalContext'
import { Badge } from '@/design-lib/components/Badge'
import Icon from '@/design-lib/components/Icons'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'
import getTranslatedTitle from '@/utils/get-translated-title'

import ModalHeaderTitle from '../ModalHeaderTitle'

import { detailModalHeaderFullScreen, streetViewModalOuter, streetviewBadge } from './styles.css'

type Props = {
  cities: ContextValue
  closeModal: ModalContextType['closeModal']
  property: ListingCate
}

const StreetView: React.FC<Props> = ({ cities, ...props }) => {
  const device = useDevice()
  const { lang, t } = useTranslation()
  const {
    publicRuntimeConfig: { googleMapsApiKey },
  } = getConfig()

  const listingCity = cities.list.find((city) => city.slug === props.property.detail.city)
  const SVWindowHeight = device === 'mobile' ? '100vh' : 'calc(100vh - 167px)'

  return (
    <div className={streetViewModalOuter}>
      <div className={cn(detailModalHeaderFullScreen, sprinkles({ display: 'flex', justifyContent: 'flex-end' }))}>
        {device === 'desktop' ? (
          <>
            <ModalHeaderTitle
              cityName={listingCity.translatedCityName}
              closeModal={props.closeModal}
              title={getTranslatedTitle(props.property.detail.titles, lang)}
            />
            <div className={sprinkles({ alignItems: 'center', display: 'flex' })}>
              <LocationZone className={sprinkles({ marginRight: 's' })} />
              <BodyLarge>{t('listing-detail:street-view.description')}</BodyLarge>
            </div>
          </>
        ) : (
          <ButtonCircleIcon ariaLabel="close dialog" onClick={() => props.closeModal()}>
            <Icon.Close />
          </ButtonCircleIcon>
        )}
      </div>
      <div style={{ height: SVWindowHeight, position: 'relative' }}>
        {!props.property.showStreetNumber && (
          <Badge
            className={streetviewBadge}
            icon="HouseSmall"
            label={t('listing-detail:street-view.address-disclaimer')}
            styleVariant="greyscale"
          />
        )}
        <iframe
          allowFullScreen={false}
          height="100%"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/streetview?location=${props.property.coordinates.lat},${props.property.coordinates.lon}&key=${googleMapsApiKey}&source=outdoor&radius=50&pitch=0&heading=0`}
          style={{ border: 0 }}
          title="streetview"
          width="100%"
        ></iframe>
        <div style={{ height: 20 }} />
      </div>
    </div>
  )
}

export default StreetView
